// extracted by mini-css-extract-plugin
module.exports =  {"wcInjuryContainer":"InjuryPage_wcInjuryContainer__f+SPk","wcInjuryDetail":"InjuryPage_wcInjuryDetail__VBvnz","wcAddInjuryDeleteIcon":"InjuryPage_wcAddInjuryDeleteIcon__05eXa"};